import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IInitialisedPaymentLinkVm } from '../initialised-payment-link-vm.model';
import { IPlatformSubscriptionsOrderIm } from '../platform-subscriptions-order-im.model';
@Injectable({ providedIn: 'root' })
export class MyOskPlatformSubscriptionOrderService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskPlatformSubscriptionOrder`;
  }
  post(platformSubscriptionsOrderIm: IPlatformSubscriptionsOrderIm): Observable<IInitialisedPaymentLinkVm> {
    const headers = this.createHeaders();
    return this.http.post<IInitialisedPaymentLinkVm>(this.baseUrl, platformSubscriptionsOrderIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
